import { useRef, useState } from 'react';

import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { Vereador } from '../../typesSite/vereador/Vereador';
import useVereadorSiteFetch from './useVereadorSiteFetch';


type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: Vereador | null;
  handleSearchChange: (newValue: Vereador) => void;
};

const TxtVereadorSite = ({ isdisabled, isLoading, required, value, handleSearchChange }: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState('');
  const { options } = useVereadorSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => {
        const vereadorSite = option as Vereador;
        let descricao: string = '';

        if (!vereadorSite) {
          return '';
        }

        if (vereadorSite.nome) {
          descricao = vereadorSite.nome;
        }

        if (vereadorSite.legislatura) {
          descricao = vereadorSite.nome + ' (' + vereadorSite.legislatura + ')';
        }

        return descricao;
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as Vereador);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Vereador"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
export default TxtVereadorSite;
